export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/d9f26165e744ef064b81249371ce3c44.svg";